export default __webpack_public_path__ + "static/media/ga1_lrg.8d04d859.jpg";